import { render } from "./DonationSuccess.vue?vue&type=template&id=1b5f2d64&scoped=true"
import script from "./DonationSuccess.vue?vue&type=script&lang=js"
export * from "./DonationSuccess.vue?vue&type=script&lang=js"

import "./DonationSuccess.vue?vue&type=style&index=0&id=1b5f2d64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b5f2d64"]])

export default __exports__